import React, { type ForwardedRef } from 'react';

const useForwardRef = <T>(ref: ForwardedRef<T>, initialValue: any = null) => {
	const targetRef = React.useRef<T>(initialValue);

	React.useEffect(() => {
		if (!ref) return;

		if (typeof ref === 'function') {
			ref(targetRef.current);
		} else {
			ref.current = targetRef.current;
		}
	}, [ref]);

	return targetRef;
};

export default useForwardRef;
